var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"audio",attrs:{"src":"/audio/chime.mp3","preload":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }